var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.333,
    height: 23.333,
    viewBox: "0 0 23.333 23.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.554,10.1V6.2A6.2,6.2,0,0,0,14.4,0H8.932A6.2,6.2,0,0,0,2.78,6.2v3.9A4.82,4.82,0,0,0,0,14.4a4.869,4.869,0,0,0,4.831,4.831h.684V9.616H4.831a4.724,4.724,0,0,0-.684.069v-2.8H5.514V6.2A3.422,3.422,0,0,1,8.932,2.78H14.4A3.422,3.422,0,0,1,17.819,6.2v.684h1.367v2.8a4.724,4.724,0,0,0-.684-.069h-.684v9.616H18.5a4.724,4.724,0,0,0,.684-.069V20.6a.684.684,0,0,1-.684.684H14.192a1.347,1.347,0,0,0-1.158-.684H10.3a1.367,1.367,0,0,0,0,2.734h2.734a1.348,1.348,0,0,0,1.158-.684H18.5A2.053,2.053,0,0,0,20.554,20.6V18.752a4.888,4.888,0,0,0,2.78-4.351A4.82,4.82,0,0,0,20.554,10.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.044641a941a9789704db22c7634490db.svg";
export { ForwardRef as ReactComponent };